import { render, staticRenderFns } from "./Document.vue?vue&type=template&id=5b6ddf2c&scoped=true&"
import script from "./Document.vue?vue&type=script&lang=js&"
export * from "./Document.vue?vue&type=script&lang=js&"
import style0 from "./Document.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Document.vue?vue&type=style&index=1&id=5b6ddf2c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b6ddf2c",
  null
  
)

export default component.exports